import { isNaN as lodashIsNaN } from 'lodash-es'
import { differenceInYears } from 'date-fns'

import VueScrollTo from 'vue-scrollto'

const scrollToBottom = (elementId) => {
  // run it after a sec as let the store update components
  setTimeout(function () {
    let container = document.getElementById(elementId)
    container = container === null ? document.getElementsByClassName(elementId)[0] : container
    if (!container) return
    const top = container.scrollHeight
    container.scroll({ top: top, behavior: 'smooth' })
  }, 1)
}

/**
 * @param {string} elementId
 */
const scrollIntoView = (elementId) => {
  // run it after a sec as let the store update components
  setTimeout(function () {
    let container = document.getElementById(elementId)
    container = container === null ? document.getElementsByClassName(elementId)[0] : container
    if (container) {
      VueScrollTo.scrollTo(`#${elementId}`, 500, {})
      // container.scrollIntoView({behavior: behaviour, block: 'start', inline: 'start'})
    }
  }, 1)
}

const calculateAge = (birthday) => {
  const age = differenceInYears(new Date(), birthday)
  return lodashIsNaN(age) ? 0 : age
}

const formatCurrency = (number) => {
  if (lodashIsNaN(number) || number === null || number === '$') {
    return null
  }

  let val = getStringToNumber(number)
  const sign = val < 0 ? '-$' : '$'
  val = val < 0 ? val * -1 : val
  return sign + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const getStringToNumber = (number) => {
  number = clearNumberString(number)
  return Math.ceil(Number(number))
}

// return a number or text
const clearNumberString = (number) => {
  if (typeof number !== 'string') return number
  return number.replace(/[^0-9-.]+/g, '')
}

const formatPercentage = (number) => {
  return number && lodashIsNaN(number) ? '0%' : `${number}%`
}

const abbrNum = (number, decPlaces = 2) => {
  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = Math.pow(10, decPlaces)

  // Enumerate number abbreviations
  const abbrev = ['k', 'm', 'b', 't']

  // Go through the array backwards, so we do the largest first
  for (let i = abbrev.length - 1; i >= 0; i--) {
    // Convert array index to "1000", "1000000", etc
    const size = Math.pow(10, (i + 1) * 3)

    // If the number is bigger or equal do the abbreviation
    if (size <= number) {
      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
      // This gives us nice rounding to a particular decimal place.
      number = Math.round((number * decPlaces) / size) / decPlaces

      // Handle special case where we round up to the next abbreviation
      if (number === 1000 && i < abbrev.length - 1) {
        number = 1
        i++
      }

      // Add the letter for the abbreviation
      number += abbrev[i]

      // We are done... stop
      break
    }
  }

  return number
}

const capitalize = (value) => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

const getMonthNameByIndex = (monthIndex) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return monthNames[monthIndex]
}

const isItMobile = () => {
  return !!(
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  )
}

const convertCamelCase = (text) => {
  // insert a space before all caps
  return text.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase()
  })
}

const getRootColor = (variable) => {
  const style = getComputedStyle(document.body)
  return style.getPropertyValue(`--${variable}`)
}

const formatNumber = (number) => {
  if (number === null || number === undefined || lodashIsNaN(number)) return number
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export {
  scrollToBottom,
  scrollIntoView,
  calculateAge,
  formatCurrency,
  formatPercentage,
  capitalize,
  abbrNum,
  getMonthNameByIndex,
  isItMobile,
  clearNumberString,
  getStringToNumber,
  convertCamelCase,
  getRootColor,
  formatNumber,
}
